




























































































































































































































































// @ts-nocheck
import Vue from 'vue'
import axios from 'axios';
import DateCellRenderer from '@/components/DateCellRenderer.vue';
import TimeCellRenderer from '@/components/TimeCellRenderer.vue';
import TextCellRenderer from '@/components/TextCellRenderer.vue';
import ActionCellRenderer from '@/components/ag-grid/ActionCellRenderer.vue';
import TimeEntryForm from '@/components/TimeEntryForm.vue';
import { differenceInMinutes, format, compareAsc } from 'date-fns';
import { mdiCloseCircleMultiple } from '@mdi/js';
import BulkActionsDialog from '@/components/BulkActionsDialog.vue';
import _ from 'lodash';

export default Vue.extend({
    components: {
        TimeEntryForm,
        BulkActionsDialog
    },
    data() {
        return {
            search: '',
            isShowSummaryHours: true,
            isShowSummaryProjectName: true,
            isShowBilled: false,
            isShowBillable: true,
            isBilledAtModalOpen: false,
            clearAllIcon: mdiCloseCircleMultiple,
            client: null as Client | null,
            gridOptions: {
                rowHeight: 38
            } as any,
            gridApi: null as any | null,
            columnApi: null as any | null,
            users: [] as any[],
            columnDefs: [] as any[],
            timeEntries: [] as any[],
            rowData: [] as any[],
            isShowTimeEntrySheet: false,
            isShowConfirmationDelete: false,
            isSaving: false,
            timeEntry: null as null | any,
            previousInvoices: [] as string[],
            previousProjects: [] as string[],
            selectedItems: [] as any[],
            isShowSelectedSummary: false,
            isShowBulkActions: false,
            projects: [] as any[]
        }
    },
    async beforeMount() {
        // this.$store.dispatch();
    },
    async mounted(): Promise<void>  {
        await this.getUsers();
        await this.getClient();
        await this.getClients();
        await this.getWorkTypes();
        await this.getTimeEntries();
        await this.getProjects();

        this.$store.commit('TITLE_ITEMS', {
            action: this.getClients,
            items: this.$store.state.clients
        });

        this.gridOptions.rowClassRules = {
            'record-unbillable': (params: any) => {
                const record = this.timeEntries.find(x => x.id == params.data.id);
                return record.billable != null && !record.billable;
            },
            'record-billed': (params: any) => {
                const record = this.timeEntries.find(x => x.id == params.data.id);
                return record.billed_at;
            },
        };

        this.gridOptions.getRowNodeId = (data: any) => {
            return data.id;
        };

        this.columnDefs = [
            {
                headerName: 'Actions',
                editable: false,
                colId: 'params',
                field: 'value',
                cellRendererFramework: ActionCellRenderer,
                cellRendererParams: {
                    getSelectedStatus: this.getSelectedStatus,
                    toggle: this.toggleEntry,
                    remove: this.confirmRemoveEntry,
                    edit: this.editEntry,
                    billed: this.recordBilled
                },
                width: 150
            },
            {
                headerName: 'Date',
                field: 'started_at',
                sortable: true,
                filter: true,
                editable: false,
                cellRendererFramework: DateCellRenderer,
                cellRendererParams: {
                    // format: 'ddd/DD/YYYY - hh:mm A'
                    format: 'ddd, MMMM DD, YYYY'
                },
                width: 150,
                comparator: compareAsc
            },
            {
                headerName: 'Start',
                field: 'started_at',
                sortable: true,
                filter: true,
                editable: false,
                cellRendererFramework: DateCellRenderer,
                cellRendererParams: {
                    format: 'hh:mm A'
                },
                width: 100
            },
            {
                headerName: 'End',
                field: 'ended_at',
                sortable: true,
                filter: true,
                editable: false,
                cellRendererFramework: DateCellRenderer,
                cellRendererParams: {
                    format: 'hh:mm A'
                },
                width: 100
            },
            {
                headerName: 'Time',
                field: 'time',
                sortable: true,
                filter: true,
                cellRendererFramework: TimeCellRenderer,
                cellRendererParams: {
                    calculate: this.calculateTime
                },
                comparator: (valueA: any, valueB: any, nodeA: any, nodeB: any) => {
                    const timeA = this.calculateTime(nodeA.data);
                    const timeB = this.calculateTime(nodeB.data);
                    return timeB - timeA; // Descending order
                },
                editable: false,
                width: 80
            },
            {
                headerName: 'Project',
                field: 'project',
                sortable: true,
                filter: true,
                editable: false
            },
            {
                headerName: 'Employee',
                field: 'employee_id',
                sortable: true,
                filter: true,
                editable: false,
                valueFormatter: (params: any) => {
                    return this.renderEmployeeColumn("employee_id", params.data);
                },
                valueGetter: (params: any) => {
                    return this.renderEmployeeColumn("employee_id", params.data);
                },
                width: 150
            },
            {
                headerName: 'Entered By',
                field: 'entered_by',
                sortable: true,
                filter: true,
                editable: false,
                valueFormatter: (params: any) => {
                    return this.renderEmployeeColumn("entered_by", params.data);
                },
                valueGetter: (params: any) => {
                    return this.renderEmployeeColumn("entered_by", params.data);
                },
                width: 150
            },
            {
                headerName: 'Work Type',
                field: 'work_type_id',
                sortable: true,
                filter: true,
                editable: false,
                cellRendererFramework: TextCellRenderer,
                cellRendererParams: {
                    render: this.renderWorkType
                },
                width: 150
            },
            {
                headerName: 'Notes',
                field: 'notes',
                sortable: true,
                filter: true,
                editable: false,
                width: 400
            },
            {
                headerName: 'Invoice',
                field: 'invoice_number',
                sortable: true,
                filter: true,
                editable: false,
                width: 200
            },
            {
                headerName: 'Billed',
                field: 'billed_at',
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: (params: any) => {
                    return `${params.value ? `<span class='date-value ml-1'>${format(params.value, 'ddd, MMM DD, YYYY')}</span>` : ''}`;
                }
            },
            {
                headerName: 'Billable',
                field: 'billable',
                sortable: true,
                filter: true,
                editable: true,
                cellRenderer: (params: any) => {
                    return `<input type='checkbox' disabled="disabled" ${params.value ? 'checked' : ''} />`;
                }
            }
        ]

        const cachedTimeEntry = localStorage.getItem('time_entry');
        if (cachedTimeEntry) {
            try {
                this.timeEntry = JSON.parse(cachedTimeEntry);
                this.isShowTimeEntrySheet = true;
            } catch (e) {
                //
            }

            localStorage.removeItem('time_entry');
        }
    },
    methods: {
        toggleVisible() {
            if (this.isAllSelected) {
                this.selectedItems = [];
            } else {
                // CASE: only get the items that are visible since we may be filtered on columns
                this.selectedItems = this.gridApi.getModel().rowsToDisplay.map((x: any) => x.data);
            }
        },
        closeTimeEntryForm() {
            this.isShowTimeEntrySheet = false;
            this.timeEntry = null;
        },
        toggleBilledItems() {
            this.isShowBilled = !this.isShowBilled;

            this.getTimeEntries();
        },
        onGridReady(params: any) {
            this.gridApi = params.api;
            this.columnApi = params.columnApi;
        },
        // update local state of time entries after bulk update
        updatedBulkItems(items: any[]) {
            const selectedIds = this.selectedItems.map(x => x.id);

            for (const item of items) {
                const existingItem = this.timeEntries.find(x => x.id === item.id);

                if (existingItem == null) {
                    continue;
                }

                const index = this.timeEntries.indexOf(existingItem);
                if (index === -1) {
                    continue;
                }

                this.timeEntries.splice(index, 1, item);
                
                const model = this.gridOptions.api.getModel();
                const row = model.rowsToDisplay.find((x: any) => x.data.id === item.id);
                row.setData(item);

                for (let i = 0; i < this.rowData.length; i++) {
                    if (this.rowData[i].id === existingItem.id) {
                        this.rowData[i] = Object.assign(this.rowData[i], item);
                        break;
                    }
                }
            }

            this.selectedItems = this.timeEntries.filter(x => selectedIds.indexOf(x.id) > -1);
            
            this.isShowBulkActions = false;
        },
        showBulkActions() {
            this.isShowBulkActions = true;
        },
        renderEmployeeColumn(field: string, record: any) {
            if (record[field]) {
                const user = this.users.find(x => x.id == record[field]);
                
                if (user) {
                    return user.first_name + ' ' + user.last_name
                }
            }
        },
        async getProjects() {
            try {
                const result = await axios.get(`/projects?client_id=${this.client?.id}`);
                this.projects = _.orderBy(result.data, ['name'], ['asc']);
            } catch (e) {
                console.error(e);
            }
        },
        async getUsers() {
            try {
                const result = await axios.get(`/users`);
                this.users = result.data;
            } catch (e) {
                console.error(e);
            }
        },
        getSelectedStatus(data: any): boolean {
            return !!this.selectedItems.find(x => x.id == data.id);
        },
        trackInvoiceNumber(invoice: string | null) {
            if (!invoice) {
                return;
            }

            if (this.previousInvoices.indexOf(invoice) == -1) {
                this.previousInvoices.unshift(invoice);
            }

            this.previousInvoices = this.previousInvoices.slice(0, 2);
        },
        trackProject(project: string | null) {
            if (!project) {
                return;
            }

            if (this.previousProjects.indexOf(project) == -1) {
                this.previousProjects.unshift(project);
            }

            this.previousProjects = this.previousProjects.slice(0, 2);
        },
        recordBilled(data: any) {
            const record = this.timeEntries.find(x => x.id == data.id);
            if (!record) {
                return null;
            }

            return record.billed_at;
        },
        async getClients(): Promise<void> {
            try {
                const result = await axios.get('/clients');
                this.$store.dispatch('SET_CLIENTS', result.data);
            } catch (e) {
                console.error(e);
            }
        },
        async getTimeEntries(): Promise<void>  {
            try {
                console.log("Client", this.client)
                const result = await axios.get(`/clients/${this.client?.id}/time-entries?${this.isShowBilled? 'showBilled=1' : ''}`);
                this.timeEntries = result.data;
                this.rowData = [...result.data];
            } catch (e) {
                console.error(e);
            }
        },
        async getWorkTypes(): Promise<void>  {
            try {
                const result = await axios.get('/settings/worktypes');
                this.$store.commit('WORK_TYPES', result.data);
            } catch (e) {
                console.error(e);
            }
        },
        async getClient(): Promise<void>  {
            try {
                const result = await axios.get(`/clients/${this.$route.params.id}`);
                this.client = result.data;
                
                this.$store.commit("TITLE_BAR", this.client?.name);
                console.log("setting", this.client)
                this.$store.dispatch("SET_CLIENT", this.client);
            } catch (e) {
                console.error(e);
            }
        },
        calculateTime(data: any): string | number  {
            const record = this.timeEntries.find(x => x.id == data.id);

            if (!record || !record.ended_at) {
                return ''
            }
            
            return Math.ceil((differenceInMinutes(record.ended_at, record.started_at) / 60) * 10)/ 10;
        },
        confirmRemoveEntry(data: any) {
            this.timeEntry = this.timeEntries.find(x => x.id == data.id);
            
            if (!this.timeEntry) {
                return;
            }

            this.isShowConfirmationDelete = true;
        },
        toggleEntry(data: any) {
            const timeEntry = this.timeEntries.find(x => x.id == data.id);
            const index = this.selectedItems.indexOf(timeEntry);
            
            if (index > -1) {
                timeEntry.selected = false;
                this.selectedItems.splice(index, 1);
            } else {
                timeEntry.selected = true;
                this.selectedItems.push(timeEntry);
            }
        },
        clearSelectedItems() {
            this.selectedItems.forEach(x => x.selected = false);
            this.selectedItems = [];
        },
        editEntry(data: any) {
            this.timeEntry = this.timeEntries.find(x => x.id == data.id);
            this.isShowTimeEntrySheet = true;
        },
        openTimeEntry(): void {
            this.isShowTimeEntrySheet = true;
        },
        renderWorkType(data: any): string {
            const workType = this.$store.state.workTypes.find((x: any) => x.id === data.work_type_id);
            if (!workType) {
                return '';
            }

            return workType.name;
        },
        async cancelDeleteTimeEntry(): Promise<void>  {
            this.isShowConfirmationDelete = false
        },
        async deleteTimeEntry(): Promise<void>  {
            if (!this.timeEntry) {
                this.isShowConfirmationDelete = false;
                return;
            }

            try {
                await axios.delete(`/time-entries/${this.timeEntry.id}`);
                const oldEntry = this.timeEntries.find((x: any) => x.id === this.timeEntry.id);
                const index = this.timeEntries.indexOf(oldEntry);

                if (index > -1) {
                    this.timeEntries.splice(index, 1);
                    this.rowData = [...this.timeEntries];
                }
            } catch (e) {
                console.error(e);
            }

            this.isShowConfirmationDelete = false;
        },
        async saveTimeEntry({ isEdit, timeEntry }: { isEdit: boolean; timeEntry: any }): Promise<void> {
            if (this.isSaving) {
                return;
            }

            this.trackInvoiceNumber(timeEntry.invoice_number);
            this.trackProject(timeEntry.project);

            this.isSaving = true;
            this.timeEntry = null;
            
            if (timeEntry.billed_date) {
                timeEntry.billed_at = new Date(timeEntry.billed_at);
            }

            // CASE: timed out but still trying to enter
            localStorage.setItem('redirect_uri', window.location.pathname);
            localStorage.setItem('time_entry', JSON.stringify(timeEntry));

            const isCurrentClientEntry = timeEntry.client_id == this.$store.state.client.id;
            const selectedIds = this.selectedItems.map(x => x.id);

            if (isEdit && timeEntry.id) {
                try {
                    const result = await this.$axios.put(`/time-entries/${timeEntry.id}`, timeEntry);
                    const oldEntry = this.timeEntries.find((x: any) => x.id === timeEntry.id);
                    const index = this.timeEntries.indexOf(oldEntry);
                    
                    if (index > -1) {
                        const model = this.gridOptions.api.getModel();
                        const row = model.rowsToDisplay.find((x: any) => x.data.id === timeEntry.id);
                        
                        if (isCurrentClientEntry) {
                            this.timeEntries.splice(index, 1, result.data);
                            row.setData(result.data);
                            
                            for (let i = 0; i < this.rowData.length; i++) {
                                if (this.rowData[i].id === timeEntry.id) {
                                    this.rowData[i] = Object.assign(this.rowData[i], result.data);
                                }
                            }
                        } else {
                            this.timeEntries.splice(index, 1);
                            this.rowData = [...this.timeEntries];
                        }
                    }
                } catch (e) {
                    alert("Error saving time entry");
                    console.error(e);
                }
            } else {
                try {
                    const result = await this.$axios.post('/time-entries', timeEntry);
                    
                    if (isCurrentClientEntry) {
                        // CASE: find a record to insert before
                        // TODO: improve sorting
                        const record = this.timeEntries.find(x => x.started_at < result.data.started_at);
                    
                        if (record) {
                            const index = this.timeEntries.indexOf(record);

                            if (index > -1) {
                                this.timeEntries.splice(index, 0, result.data);
                                this.rowData = [...this.timeEntries];
                            }
                        } else {
                            this.timeEntries.push(result.data);
                            this.rowData = [...this.timeEntries];
                        }
                    }
                } catch (e) {
                    alert("Error saving time entry");
                    console.error(e);
                }
            }

            this.trackInvoiceNumber(timeEntry.invoice_number);
            this.trackProject(timeEntry.project);

            this.isSaving = false;
            this.timeEntry = null;
            this.selectedItems = this.timeEntries.filter(x => selectedIds.indexOf(x.id) > -1);
            
            localStorage.removeItem('redirect_uri');
            localStorage.removeItem('time_entry');
        },
        format
    },
    computed: {
        clients(): Client[] {
            return this.$store.state.clients;
        },
        isAllSelected() {
            if (!this.gridApi) {
                return false;
            }

            return this.selectedItems.length === this.gridApi.getModel().rowsToDisplay.map((x: any) => x.data).length;
        },
        billableData() {
            if (this.isShowBillable) {
                return this.rowData;
            }

            return this.rowData.filter(x => x.billable);
        },
        visibleData() {
            if (this.isShowBilled) {
                return this.billableData;
            }

            return this.billableData.filter(x => !x.billed_at);
        },
        filteredData() {
            if (!this.search) {
                return this.visibleData;
            }

            return this.visibleData.filter((x: any) => {
                return JSON.stringify(x).toLowerCase().includes(this.search.toLowerCase());
            });
        },
        activeUsers(): any[] {
            return this.users.filter(x => !x.deleted_at);
        },
        selectedSummary() {
            if (!this.selectedItems || this.selectedItems.length === 0) {
                return null;
            }

            const projects = {} as any;

            for (const item of this.selectedItems) {
                if (!projects[item.project]) {
                    projects[item.project] = [];
                }

                projects[item.project].push(item);
            }

            return projects;
        },
        selectedItemFirstDate(): any | null {
            if (!this.selectedItems) {
                return null;
            }

            let earliestItem = null;

            for (const item of this.selectedItems) {
                if (earliestItem == null) {
                    earliestItem = item;
                }

                if ((item as any).started_at < earliestItem.started_at) {
                    earliestItem = item;
                }
            }

            return earliestItem;
        },
        selectedItemLastDate(): any | null  {
            if (!this.selectedItems) {
                return null;
            }

            let latestDate = null;

            for (const item of this.selectedItems) {
                if (latestDate == null) {
                    latestDate = item;
                }
                
                if ((item as any).started_at > latestDate.started_at) {
                    latestDate = item;
                }
            }

            return latestDate;
        },
        totalHoursSelected(): number {
            const reducer = (accumulator: number, currentValue: number): number => accumulator + currentValue;

            return this.selectedItems.map((x: any) => {
                if (!x.ended_at) {
                    return 0;
                }

                return this.calculateTime(x) as number || 0;
            }).reduce(reducer, 0);
        },
        gridStyles() {
            const top = 250;
            return `width: 100%; height: calc(100vh - ${top}px);`
        },
        totalHours(): number {
            let total = 0;

            this.timeEntries.forEach(x => {
                if (!x.ended_at || !x.started_at) {
                    return;
                }

                total += differenceInMinutes(x.ended_at, x.started_at);
            });

            return Math.ceil((total / 60) * 10)/ 10;
        },
        totalUnbilledHours(): number {
            let total = 0;

            this.timeEntries.forEach(x => {
                if (!x.ended_at || !x.started_at || x.billed_at || !x.billable) {
                    return;
                }

                total += differenceInMinutes(x.ended_at, x.started_at);
            });

            return Math.ceil((total / 60) * 10)/ 10;
        },
        totalCost(): number {
            if (!this.$store.state.client) {
                return 0;
            }
            
            return this.totalHours * this.$store.state.client.hourly_rate;
        },
        totalUnbilled(): number {
            if (!this.$store.state.client) {
                return 0;
            }

            return this.totalUnbilledHours * this.$store.state.client.hourly_rate;
        }
    }
});
